// extracted by mini-css-extract-plugin
export default {"price":"O--z","onSale":"P--z","msrpLabelPrice":"Q--z","msrpLabel":"R--z","originalPrice":"S--z","percentOff":"T--z"};